import { useMutation, useQueryClient } from '@tanstack/react-query'
import { detachDomain } from '../../services'
import { AdminMutationKey, AdminQueryKey } from '@/modules/admin/keys'
import { DetachDomainRequest, DetachDomainResponse } from '@/modules/admin/type'
import { toast } from 'sonner'

export default function useMutationDetachDomain() {
	const queryClient = useQueryClient()

	return useMutation<DetachDomainResponse, Error, DetachDomainRequest>({
		mutationKey: [AdminMutationKey.DetachDomain],
		mutationFn: (payload: DetachDomainRequest) => detachDomain(payload),
		onSuccess: (data) => {
			toast.success(data.message || 'ลบโดเมนสำเร็จ')
			queryClient.invalidateQueries({ queryKey: [AdminQueryKey.GetDomains] })
		},
		onError: () => {
			toast.error('ลบโดเมนล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
